import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtText from "../../../components/NtText";
import NtTouchableEffect from "../../../components/NtTouchableEffect";

function NtAppDownloadButton({ type = "apple", containerStyle, onPress }) {
  let title = "Download on the";
  let subtitle = "App Store";
  let image = require("../../../assets/images/marketing/apple-store-logo.png");

  if (type == "android") {
    title = "Get it on";
    subtitle = "Play Store";
    image = require("../../../assets/images/marketing/google-play-logo.png");
  }

  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      <Image
        style={[
          {
            width: 30,
            height: 30,
            borderRadius: 10,
            resizeMode: "contain",
          },
        ]}
        source={image}
      />
      <View style={{ marginLeft: 15, marginRight: 10 }}>
        <NtText
          style={{
            fontSize: 12,
            fontWeight: "400",
            color: "black",
          }}
        >
          {title}
        </NtText>
        <NtText style={{ fontSize: 20, fontWeight: "900", color: "black" }}>
          {subtitle}
        </NtText>
      </View>
    </NtTouchableEffect>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: 10,
    flexDirection: "row",
    alignItems: "center",
  },
});

export default NtAppDownloadButton;
